import React, { useState } from 'react';
import Header from '../../welcome/components/Header';
import Agreement from '../components/Agreement';
import RegisterForm from '../components/RegisterForm';


const  Registration: React.FC = () => {
  const [isAgreed, setIsAgreed] = useState(false);
  
  return (
    <React.Fragment>
      <Header />
      {!isAgreed && <Agreement onAgree={() => setIsAgreed(true)} />}
      {isAgreed && <RegisterForm />}
    </React.Fragment>
  )
}

export default Registration;